import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoCompleteKeyword } from "@/model";
import autoCompleteKeywordRepository from "@/repository/autoCompleteKeywordRepository";


interface DeleteAutocompleteKeywordsProps {
    ids?: string[];
    keyword?: string;
}

export const useDeleteAutocompleteKeywords = (agentId: number, autocompleteId: string) => {
    const queryClient = useQueryClient();

    return useMutation<AutoCompleteKeyword, AxiosError, DeleteAutocompleteKeywordsProps>({
        mutationKey: [agentId, "autocomplete-keyword", "delete-many"],
        mutationFn: async (props: DeleteAutocompleteKeywordsProps) => {
            try {
                const res = await autoCompleteKeywordRepository.deleteMany(agentId, autocompleteId, props.ids, props.keyword);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["autocomplete-keyword"]
            });
        }
    });
};
